export default __webpack_public_path__ + "static/media/ex-blog-post.831f4f82.jpg";